import { hDeepCopy } from '@/utils/helpers';

const formFields = {
  terms: {
    key: 'terms',
    type: 'checkbox_one',
    label: '',
    allowHtml: true,
    rules: [
      { required: true, message: 'Pole jest wymagane.', trigger: 'change' },
    ],
  },
  login: {
    key: 'login',
    type: 'text',
    label: 'Login',
    placeholder: 'Login',
    prepend: '<i class="fa fa-user" aria-hidden="true"></i>',
    rules: [
      { required: true, message: 'Pole jest wymagane.', trigger: 'blur' },
    ],
  },
  reminder_password: {
    key: 'reminder_password',
    type: 'reminder_password',
    label: 'Nie pamiętasz hasła?',
    placeholder: 'Login',
    prepend: '<i class="fa fa-user" aria-hidden="true"></i>',
    rules: [],
  },
  change_password: {
    key: 'change_password',
    type: 'change_password',
    label: 'Powtórz hasło',
    placeholder: 'Potwierdź hasło na które chcesz zmienić.',
    prepend: '<i class="fa fa-unlock-alt" aria-hidden="true"></i>',
    rules: [],
  },
  password: {
    key: 'password',
    type: 'password',
    label: 'Hasło',
    placeholder: 'Min. 8 znaków, jedna cyfra, jedna wielka litera',
    prepend: '<i class="fa fa-unlock-alt" aria-hidden="true"></i>',
    rules: [
      { required: true, message: 'Pole jest wymagane.', trigger: 'blur' },
      { min: 8, message: 'Hasło musi posiadać minimalnie 8 znaków.', trigger: 'change' },
      { validator: (rule, value, callback) => {
        if (!(/[A-Z]/).test(value)) {
          callback(new Error('Hasło musi zawierać co najmniej jedną wielką literę'));
        }
        if (!(/\d/).test(value)) {
          callback(new Error('Hasło musi zawierać co najmniej jedną cyfrę'));
        }
        callback();
      },
      },
    ],
  },
  email: {
    key: 'email',
    type: 'text',
    label: 'E-mail',
    placeholder: 'Adres email',
    prepend: '<i class="fa fa-envelope" aria-hidden="true"></i>',
    rules: [
      { type: 'email', required: true, message: 'Nieprawidłowy adres email.', trigger: 'blur' },
    ],
  },
  name: {
    key: 'name',
    type: 'text',
    label: 'Imię',
    placeholder: 'Imię',
    prepend: '<i class="fa fa-user" aria-hidden="true"></i>',
    rules: [
      { required: true, message: 'Pole jest wymagane.', trigger: 'blur' },
    ],
  },
  last_name: {
    key: 'last_name',
    type: 'text',
    label: 'Nazwisko',
    placeholder: 'Nazwisko',
    prepend: '<i class="fa fa-user" aria-hidden="true"></i>',
    rules: [
      { required: true, message: 'Pole jest wymagane.', trigger: 'blur' },
    ],
  },
  phone_number: {
    key: 'phone_number',
    type: 'text',
    label: 'Numer telefonu',
    placeholder: 'Numer telefonu',
    prepend: '<i class="fa fa-phone-square" aria-hidden="true"></i>',
    rules: [
      { required: true, message: 'Pole jest wymagane.', trigger: 'blur' },
      { min: 9, max: 9, message: 'Numer musi zawierać dokładnie 9 znaków.', trigger: 'change' },
      { validator: (rule, value, callback) => {
        if (!/^\d+$/.test(value)) {
          callback(new Error('Nieprawidłowy numer'));
        }
        callback();
      },
      trigger: 'blur',
      },
    ],
  },
  code: {
    key: 'code',
    type: 'text',
    label: 'Kod',
    placeholder: 'Wpisz otrzymany kod',
    prepend: '<i class="fa fa-phone-square" aria-hidden="true"></i>',
    rules: [
      { required: true, message: 'Pole jest wymagane.', trigger: 'blur' },
    ],
  },
  label: {
    key: 'label',
    type: 'label',
    label: 'Na podany w formularzu numer telefonu został wysłany kod SMS',
    placeholder: '',
    prepend: '',
    rules: [],
  },
};

export default class FormService {
  static generateFormObject(params) {
    const _params = params;
    return _params.map(field => formFields[field]);
  }

  static transformToVerificationCode(params, oldForm) {
    const model = { ...hDeepCopy(params), code: null };
    const newForm = hDeepCopy(oldForm);

    newForm.forEach((element) => {
      element.disabled = true;
    });
    newForm.push(formFields.label);
    newForm.push(formFields.code);

    return { model, newForm };
  }
}



// WEBPACK FOOTER //
// ./src/services/FormService.js